import clsx from 'clsx';
import React from 'react';
import {Icon} from '@lightricks/react-design-system';
import Link from '@/components/link';
import useContentSubmissionNavigation from '@/hooks/use-content-submission-navigation';
import styles from './ContentNavigation.module.scss';

export interface ContentNavigationProps {
  testID?: string;
  onPrevious?: () => void;
  onNext?: () => void;
}

interface NavButtonProps {
  to: string;
  testID?: string;
  className?: string;
  onClick?: () => void;
}

export function PreviousButton({
  to,
  testID,
  className,
  onClick,
}: NavButtonProps) {
  return (
    <Link
      to={to}
      data-testid={testID}
      className={clsx(styles.button, className)}
      onClick={onClick}
    >
      <Icon
        appearance="neutral"
        name="Actions-Arrow-Back-Small"
        color="currentColor"
      />
    </Link>
  );
}

export function NextButton({to, testID, className, onClick}: NavButtonProps) {
  return (
    <Link
      to={to}
      data-testid={testID}
      className={clsx(styles.button, className)}
      onClick={onClick}
    >
      <Icon
        appearance="neutral"
        name="Actions-Arrow-Forward-Small"
        color="currentColor"
      />
    </Link>
  );
}

function ContentNavigation({
  testID = 'content-navigation',
  onPrevious,
  onNext,
}: ContentNavigationProps) {
  const {previousLink, nextLink} = useContentSubmissionNavigation();

  return (
    <div className={styles.container} data-testid={testID}>
      <PreviousButton
        to={previousLink ?? '#'}
        testID={`${testID}--back-button`}
        className={clsx({[styles.hidden]: !previousLink})}
        onClick={onPrevious}
      />
      <NextButton
        to={nextLink ?? '#'}
        testID={`${testID}--forward-button`}
        className={clsx({[styles.hidden]: !nextLink})}
        onClick={onNext}
      />
    </div>
  );
}

export default ContentNavigation;
